import {InformationsStatut} from '../../../../shared/models/information-statut';

/**
 * Enum représentant les statuts possibles d'un trajet dans l'application de gestion de navette.
 */
export enum StatutTrajetEnum {
	ANNULE = 'ANNULE',
	COMPLET = 'COMPLET',
	DISPONIBLE = 'DISPONIBLE',
	RESERVE = 'RESERVE'
}

export const StatutsTrajet: Map<StatutTrajetEnum, InformationsStatut> = new Map<StatutTrajetEnum, InformationsStatut>([
	[StatutTrajetEnum.ANNULE, { cleTraduction: 'GESTION_NAVETTE.TRAJETS.STATUTS.ANNULE', couleur: 'red' }],
	[StatutTrajetEnum.COMPLET, { cleTraduction: 'GESTION_NAVETTE.TRAJETS.STATUTS.COMPLET', couleur: 'red' }],
	[StatutTrajetEnum.DISPONIBLE, { cleTraduction: 'GESTION_NAVETTE.TRAJETS.STATUTS.DISPONIBLE', couleur: 'green' }],
	[StatutTrajetEnum.RESERVE, { cleTraduction: 'GESTION_NAVETTE.TRAJETS.STATUTS.RESERVE', couleur: 'blue' }],
]);

/**
 * Collection des statuts d'un trajet pour la gestion de la navette.
 */
export const StatutsTrajetPourGestionNavette: StatutTrajetEnum[] = [
	StatutTrajetEnum.ANNULE,
	StatutTrajetEnum.COMPLET,
	StatutTrajetEnum.DISPONIBLE
];